import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [useEmailLink, setUseEmailLink] = useState(true); // Default to email link
  const { login, sendLoginLink, completeLoginWithLink, checkIfSignInLink } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if this is a sign-in link
    if (checkIfSignInLink()) {
      handleEmailLinkSignIn();
    }
  }, []);

  async function handleEmailLinkSignIn() {
    const email = window.localStorage.getItem('emailForSignIn');
    if (!email) {
      setError('Please enter your email address to complete sign-in.');
      return;
    }

    try {
      setLoading(true);
      await completeLoginWithLink(email, window.location.href);
      navigate('/dashboard');
    } catch (error) {
      console.error('Email link sign-in error:', error);
      setError('Failed to sign in with email link. Please try again.');
    }
    setLoading(false);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (useEmailLink) {
      // Send email link
      try {
        setError('');
        setMessage('');
        setLoading(true);
        await sendLoginLink(email);
        setMessage(`Login link sent to ${email}! Check your email and click the link to sign in.`);
      } catch (error) {
        setError('Failed to send login link. Please try again.');
        console.error('Login link error:', error);
      }
    } else {
      // Traditional email/password login
      try {
        setError('');
        setLoading(true);
        await login(email, password);
        navigate('/dashboard');
      } catch (error) {
        setError('Failed to sign in. Please check your credentials.');
        console.error('Login error:', error);
      }
    }

    setLoading(false);
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src="/tnf-logo.png" alt="TNF USA" className="login-logo" />
          <h1>TNF Project Hub</h1>
          <p>Together We Serve</p>
        </div>
        
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Enter your email"
            />
          </div>
          
          {!useEmailLink && (
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your password"
              />
            </div>
          )}
          
          <button 
            type="submit" 
            disabled={loading}
            className="login-button"
          >
            {loading 
              ? (useEmailLink ? 'Sending link...' : 'Signing in...') 
              : (useEmailLink ? 'Send Login Link' : 'Sign In')
            }
          </button>

          <div className="login-toggle">
            <button
              type="button"
              onClick={() => setUseEmailLink(!useEmailLink)}
              className="toggle-button"
            >
              {useEmailLink 
                ? 'Use password instead' 
                : 'Use email link instead'
              }
            </button>
          </div>
        </form>
        
        <div className="login-footer">
          <p>© 2026 TNFusa.org - All rights reserved</p>
        </div>
      </div>
    </div>
  );
}

export default Login;